export default "__VITE_ASSET__k5twSnOq__"